import segmentProps from '../lib/segmentProps';

export const RESOLVE_HELP_ARTICLE_CLICKED = {
    providers: {
        segment: {
            type: 'track',
            name: 'fe_resolve_help_article_clicked',
            props: {
                ...segmentProps,
                source: '#context.source',
                help_article: '#context.helpArticle',
            },
        },
    },
};

export const RESOLVE_HELP_TOOLTIP_CLICKED = {
    providers: {
        segment: {
            type: 'track',
            name: 'fe_resolve_help_tooltip_clicked',
            props: {
                ...segmentProps,
                source: '#context.source',
            },
        },
    },
};

export const RESOLVE_OPTION_SCREEN_CTA_CLICKED = {
    providers: {
        segment: {
            type: 'track',
            name: 'fe_resolve_option_screen_cta_clicked',
            props: {
                ...segmentProps,
                source: '#context.source',
                cta_type: '#context.ctaType',
                cta_rank: '#context.ctaRank',
            },
        },
    },
};

export const RESOLVE_OPTIONS_LIST_OPTION_CLICKED = {
    providers: {
        segment: {
            type: 'track',
            name: 'fe_resolve_options_list_option_clicked',
            props: {
                ...segmentProps,
                rank: '#context.rank',
                option: '#context.option',
            },
        },
    },
};

export const RESOLVE_FAQ_LINK_CLICKED = {
    providers: {
        segment: {
            type: 'track',
            name: 'fe_resolve_faq_link_clicked',
            props: {
                ...segmentProps,
                source: '#context.source',
            },
        },
    },
};

export const RESOLVE_SPINNER_SHOWN = {
    providers: {
        segment: {
            type: 'track',
            name: 'fe_resolve_spinner_shown',
            props: {
                ...segmentProps,
            },
        },
    },
};

export const RESOLVE_NO_MISSED_PAYMENTS_COACHING_CTA_CLICKED = {
    providers: {
        segment: {
            type: 'track',
            name: 'fe_resolve_no_missed_payments_coaching_cta_clicked',
            props: {
                ...segmentProps,
            },
        },
    },
};

export const RESOLVE_VIEW_ALL_MISSED_PAYMENTS_CLICKED = {
    providers: {
        segment: {
            type: 'track',
            name: 'fe_resolve_view_all_missed_payments_clicked',
            props: {
                ...segmentProps,
            },
        },
    },
};

export const RESOLVE_LANDING_SCREEN_CTA_CLICKED = {
    providers: {
        segment: {
            type: 'track',
            name: 'fe_resolve_landing_screen_cta_clicked',
            props: {
                ...segmentProps,
                copy: '#context.copy',
            },
        },
    },
};
